import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
  // eslint-disable-next-line import/no-internal-modules
} from '@insided/deprecated-preact-components/modal'
import Button from '@insided/control/uikit/Button'

interface Props {
  numberOfSelectedItems: number
  categoryName?: string
  isOpen: boolean
  onMoveTo: () => void
  onClose: () => void
}
const MoveToModal = ({
  numberOfSelectedItems,
  categoryName,
  isOpen,
  onMoveTo,
  onClose
}: Props) => {
  const numberOfSelectedItemsText =
    numberOfSelectedItems === 1
      ? `${numberOfSelectedItems} topic`
      : `${numberOfSelectedItems} topics`
  return (
    <Modal isOpen={isOpen} size='medium'>
      <ModalHeader title='Move topics' onClose={() => onClose()} />
      <ModalBody>
        <div className='move-to-modal'>
          <p>
            Are you sure you want to move the selected
            <span className='bold'> {numberOfSelectedItemsText} </span>to{' '}
            <span className='bold'>{categoryName}</span>?
          </p>
          <p>
            All subscribers of <span className='bold'>{categoryName}</span> will be notified about
            this change.
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          title='Move topics'
          onClick={onMoveTo}
          size='medium'
          variant='brand'
        />
        <Button title='Cancel' onClick={onClose} size='medium' />
      </ModalFooter>
    </Modal>
  )
}

export default MoveToModal
